module.exports = __webpack_public_path__ + "62cf5feac27bc8a5d986f70a4de27fa4.fbx";